import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class OrderIdProvider {

  generate(): string {
    return typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : Date.now().toString();
  }
}
